"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Global = exports.withVariants = exports.createTheme = exports.createColor = exports.extractCritical = exports.useTheme = exports.ThemeProvider = exports.keyframes = exports.CacheProvider = exports.cache = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const cache_1 = __importDefault(require("@emotion/cache"));
const react_1 = require("@emotion/react");
const react_2 = require("react");
var css_1 = require("@emotion/css");
Object.defineProperty(exports, "cache", { enumerable: true, get: function () { return css_1.cache; } });
var react_3 = require("@emotion/react");
Object.defineProperty(exports, "CacheProvider", { enumerable: true, get: function () { return react_3.CacheProvider; } });
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return react_3.keyframes; } });
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return react_3.ThemeProvider; } });
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return react_3.useTheme; } });
var server_1 = require("@emotion/server");
Object.defineProperty(exports, "extractCritical", { enumerable: true, get: function () { return server_1.extractCritical; } });
__exportStar(require("./Context"), exports);
var createTheme_1 = require("./createTheme");
Object.defineProperty(exports, "createColor", { enumerable: true, get: function () { return createTheme_1.createColor; } });
Object.defineProperty(exports, "createTheme", { enumerable: true, get: function () { return createTheme_1.createTheme; } });
Object.defineProperty(exports, "withVariants", { enumerable: true, get: function () { return createTheme_1.withVariants; } });
__exportStar(require("./styled"), exports);
const globalCache = (0, cache_1.default)({ key: 'global' });
function Global(props) {
    return ((0, jsx_runtime_1.jsx)(react_1.CacheProvider, Object.assign({ value: globalCache }, { children: (0, react_2.createElement)(react_1.Global, props) })));
}
exports.Global = Global;
